import EnumUserStatus from '../../../../../users/base/enums/EnumUserStatus';
import PageRequest from '../../../../../pagination-helper/lib/PageRequest';

/**
 * * МОдель запроса на получение детальной страницы
 */
export default class GetOwnedDetailUsersRequest  {
	/**
	 * * Поиск
	 */
	Search!: string;
	/**
	 * * Фильтрация по списку статусов
	 */
	StatusList!: Array<EnumUserStatus>;
	/**
	 * * Постраничка
	 */
	Page!: PageRequest;
	/**
	 * * Номер проекта
	 */
	ProjectId?: number;
	/**
	 * * Сортировать по ФИО (true - от Z до A, false - от A до Z)
	 */
	SortByName?: boolean = false;
	/**
	 * * Сортировать по количеству проектов (true - от большего к меньшему, false - от меньшего к большему)
	 */
	SortByProjects?: boolean = false;
	/**
	 * * Сортировать по дате рождения (true - сначала новые, false - сначала старые)
	 */
	SortByDateOfBirth?: boolean = false;
	constructor(obj?: Partial<GetOwnedDetailUsersRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
